/**
 * RFC 4122 version-4 UUID (random).
 * Uses the Web Crypto API in browsers and Node 19+; weak fallback for legacy environments.
 */
export function uuidv4 (): string {
  if (typeof globalThis.crypto !== 'undefined' && typeof globalThis.crypto.randomUUID === 'function') {
    return globalThis.crypto.randomUUID()
  }
  // Fallback (no secure RNG): sufficient when crypto.randomUUID is unavailable (rare in this app).
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.trunc(Math.random() * 16) | 0) & 0x0f
    if (c === 'x') {
      return r.toString(16)
    }
    return (r & 0x3 | 0x8).toString(16)
  })
}
